export default __webpack_public_path__ + "static/media/banner11.7192093d.png";